import React, { useState, useRef } from 'react';
import './ImageUploader.css';

const ImageUploader = ({ onImageSelected, selectedImage = null }) => {
  const [isDragging, setIsDragging] = useState(false);
  const fileInputRef = useRef(null);
  const dropZoneRef = useRef(null);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    processFile(file);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = () => {
    setIsDragging(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragging(false);
    
    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      processFile(e.dataTransfer.files[0]);
    }
  };

  const processFile = (file) => {
    if (!file) return;
    
    // Check if file is an image
    if (!file.type.match('image.*')) {
      alert('Please select an image file (JPEG, PNG, etc)');
      return;
    }
    
    const reader = new FileReader();
    reader.onload = (event) => {
      const img = new Image();
      img.onload = () => {
        onImageSelected(img);
      };
      img.src = event.target.result;
    };
    reader.readAsDataURL(file);
  };

  return (
    <div 
      className={`drop-zone ${isDragging ? 'dragging' : ''} ${selectedImage ? 'has-image' : ''}`}
      onDragOver={handleDragOver}
      onDragLeave={handleDragLeave}
      onDrop={handleDrop}
      ref={dropZoneRef}
    >
      <div className="drop-zone-content">
        <div className="upload-icon">
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 4V16M12 4L8 8M12 4L16 8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M4 17V19C4 19.5304 4.21071 20.0391 4.58579 20.4142C4.96086 20.7893 5.46957 21 6 21H18C18.5304 21 19.0391 20.7893 19.4142 20.4142C19.7893 20.0391 20 19.5304 20 19V17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </div>
        
        <p className="drop-text">
          {isDragging ? 'Drop your image here' : 'Drag & drop your image here or'}
        </p>
        
        <input 
          type="file" 
          id="file-input" 
          accept="image/*" 
          onChange={handleFileChange} 
          ref={fileInputRef}
          className="file-input"
        />
        <label htmlFor="file-input" className="file-label" style={{ backgroundColor: 'var(--primary-color)' }}>
          {selectedImage ? 'Change Image' : 'Browse Files'}
        </label>
        
        <p className="supported-formats">
          Supports: JPG, PNG, GIF, WebP (max 10MB)
        </p>
      </div>
    </div>
  );
};

export default ImageUploader; 